import { render, staticRenderFns } from "./snackbars.vue?vue&type=template&id=f597e534&scoped=true&"
import script from "./snackbars.vue?vue&type=script&lang=js&"
export * from "./snackbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f597e534",
  null
  
)

export default component.exports